import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FavoritosService } from './../../services/favoritos.service';
import { Favorito } from './../../models/favorito.model';
import { Material } from './../../models/material.model';
import { SearchService } from './../../services/search.service';

@Component({
  selector: 'app-nav-buttons',
  templateUrl: './nav-buttons.component.html',
  styleUrls: ['./nav-buttons.component.scss']
})
export class NavButtonsComponent implements OnInit {
  public list;
  public showSearchList: boolean;
  public toggleView: boolean;
  @Input() isFilter;
  @Input() urlPath;
  @Input() setButtons: any;
  @Input() materialList$: Observable<Material[]>;
  @Input() favList;
  @Output() onToggleView: EventEmitter<any> = new EventEmitter<any>();
  @Output() outletModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() printAll: EventEmitter<any> = new EventEmitter<any>();

  searchTerm = new FormControl();

  search: FormGroup = this._fb.group({
    searchTerm: this.searchTerm
  });

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private route: ActivatedRoute,
    private _location: Location,
    private _toastr: ToastrService,
    private _cookie: CookieService,
    private _search: SearchService,
    private _favoritos: FavoritosService,
  ) {
    const getView = this._cookie.get('focusListView');
    if (getView !== '') {
      this.toggleView = (getView === 'true');
    } else {
      this.toggleView = true;
    }
    this.onToggleView.emit(true);
    this.showSearchList = false;
  }

  ngOnInit() {
    this.searchTerm.valueChanges.pipe(
      debounceTime(450)
    ).subscribe( res => {
      if(res.length > 1 && !this.isFilter) {
        this._search.search(res);
        this.showSearchList = true;
      } else {
        this.showSearchList = false;
      }
    });
  }

  public emitToggleView(status: any): void {
    this.toggleView = status;
    this.onToggleView.emit(status);
    this._cookie.set( 'focusListView', status, 14, '/' );
  }

  public emitOpenModal(open: any): void {
    this.outletModal.emit(open);
  }

  voltar() {
    if (this.route.snapshot.url[0].path == 'detail') {
      localStorage.setItem('itemLocation', this.route.snapshot.params.id);
    }
    this._router.navigate(['/'], {skipLocationChange: true}).then(() => {
      this._location.back();
    });
  }

  onSubmit(): void {
    if ((this.search.value.searchTerm && this.search.value.searchTerm.length > 2) || this.search.value.searchTerm == '*') {
      if (this.isFilter) {
        this._router.navigate(['/catalogo/'+this.urlPath[0]+'/' + this.urlPath[1]], {skipLocationChange: true}).then(() => {
          this._router.navigate(['/catalogo/'+this.urlPath[0]+'/' + this.urlPath[1], this.search.value.searchTerm]);
        });
      } else {
        this._router.navigate(['/catalogo/artigos'], {skipLocationChange: true}).then(() => {
          this._router.navigate(['/catalogo/artigos', this.search.value.searchTerm]);
        });
      }
    } else {
      this._toastr.error('Sua busca deve conter mais caracteres');
    }
  }

  favAll() {
    this._favoritos.favAll(this.materialList$).subscribe();
  }

  noFavList() {
    if (this.favList && this.favList.length == 0) {
      this._toastr.error('Sua lista de favoritos não tem nenhum material');
    }
  }

  removeAllFav() {
    this._favoritos.removeAllFav().subscribe(
      (response: any) => {
        this._router.navigate(['/catalogo']);
      }
    );
  }

  print() {
    this.printAll.emit('true');
  }

}
